/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Roles } from 'utils/roles';

// Extension de FuseNavigationItem pour inclure les rôles
export interface NavigationItemWithRoles extends FuseNavigationItem {
    roles?: string[];
}

export const defaultNavigation: NavigationItemWithRoles[] = [
  {
    id: "pending-requests",
    title: "Demandes en attente",
    type: "basic",
    icon: "heroicons_outline:clock",
    link: "/dashboard/expert/pending-requests",
    roles: [Roles.ROLE_DIPITA_EXPERT], // Visible for Expert only
  },
  {
    id: "request",
    title: "Mes demandes d'avis médical",
    type: "basic",
    icon: "heroicons_outline:clipboard-document-list",
    link: "/dashboard/requester/request", // Visible for both (Expert and Requester)
  },
  {
    id: "contributions",
    title: "Mes avis médicaux",
    type: "basic",
    icon: "heroicons_outline:briefcase",
    link: "/dashboard/expert/contributions",
    roles: [Roles.ROLE_DIPITA_EXPERT], // Visible for Expert only
  },
  {
    id: "patients",
    title: "Mes patients",
    type: "basic",
    icon: "heroicons_outline:users",
    link: "/dashboard/requester/patient", // Visible for both (Expert and Requester)
  },
];

export const compactNavigation: NavigationItemWithRoles[] = [
    
];
export const futuristicNavigation: NavigationItemWithRoles[] = [
    
];
export const horizontalNavigation: NavigationItemWithRoles[] = [
    
];